import React from 'react';
import PropTypes from 'prop-types';
import useWindowWidth from '../../hooks/useWindowWidth';

import styles from './event_card.module.scss';

const EventCard = ({ title, content }) => {
  const width = useWindowWidth();

  return (
    <div className={width > 600 ? styles.card : styles.cardphone}>
      <div className={styles.header}>
        <h4>{title}</h4>
      </div>
      <div className={styles.body}>
        <p>{content}</p>
      </div>
    </div>
  );
};

EventCard.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default EventCard;
